// extracted by mini-css-extract-plugin
export default {"root":"DefaultLayout_root__CRisa","pdfRoot":"DefaultLayout_pdfRoot__Hyi8Z","fullFrame":"DefaultLayout_fullFrame__hVLVO","content":"DefaultLayout_content__Svewt"};